<template>
  <Dialog :common-dialog="productDialog" :dialog-width="dialog_width">
    <template v-slot:title>
      <v-layout class="align-center justify-space-between w-100 px-2">
        <div class="d-flex align-center">
          <v-avatar size="36" color="cyan lighten-5" class="mr-3">
            <v-icon color="cyan darken-2" small
              >mdi-package-variant-closed</v-icon
            >
          </v-avatar>
          <div class="font-weight-700 color-custom-blue d-flex align-center">
            Select {{ selectionLabel }}
            <v-chip
              label
              small
              color="cyan lighten-5"
              class="ml-3 cyan--text text--darken-3 font-weight-600"
            >
              {{ getSelectedItem }} Selected
            </v-chip>
          </div>
        </div>
        <v-flex class="text-right">
          <v-btn
            style="height: 32px !important"
            class="custom-bold-button mr-2"
            depressed
            :disabled="lProcessing"
            color="cyan white--text"
            v-on:click="save_line_item()"
            >Save</v-btn
          >
          <v-btn
            style="height: 32px !important"
            class="custom-bold-button"
            depressed
            :disabled="lProcessing"
            v-on:click="$emit('close', true)"
            >Close</v-btn
          >
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <div class="px-2 pb-2">
        <!-- Toolbar Card -->
        <div class="d-flex align-center flex-wrap gap-2 mb-3">
          <v-text-field
            v-model="search"
            class="custom-erp-input bg-white rounded-lg flex-grow-1"
            placeholder="Search product or part by name, barcode..."
            dense
            filled
            solo
            :disabled="lProcessing"
            clearable
            flat
            hide-details
            color="cyan"
            prepend-inner-icon="mdi-magnify"
            style="max-width: 400px"
            v-on:click:clear="clearSearch"
            v-on:keyup.enter="handleFilterChange()"
          />
          <v-btn
            style="height: 32px !important"
            class="custom-bold-button ml-2"
            depressed
            :disabled="lProcessing"
            v-on:click="handleFilterChange()"
            color="cyan white--text"
            >Search</v-btn
          >
          <v-autocomplete
            hide-details
            v-model.trim="filter_categoty"
            :items="lItemCategory"
            :disabled="lProcessing"
            clearable
            v-on:click:clear="filter_categoty = null"
            style="max-width: 250px !important"
            dense
            flat
            filled
            placeholder="Category"
            item-color="cyan"
            class="ml-2 bg-white rounded-lg"
            color="cyan"
            solo
            v-on:change="filter_cat($event)"
            item-value="value"
            item-text="label"
            :menu-props="{ offsetY: true }"
          >
          </v-autocomplete>
        </div>

        <!-- Product Table Card -->
        <v-card
          flat
          outlined
          class="rounded-lg border-slate bg-white overflow-hidden mb-2 shadow-0"
        >
          <div
            class="d-flex grey lighten-4 border-bottom py-2 px-3 align-center"
          >
            <div
              class="font-weight-700 text-center d-flex justify-center"
              style="width: 5%"
            >
              <v-checkbox
                :input-value="isAllVisibleSelected"
                v-on:change="update_all_line_item($event)"
                hide-details
                :disabled="lProcessing"
                class="my-0 py-0 px-0 mx-0 dense-checkbox"
                color="cyan"
              />
            </div>
            <div
              class="color-custom-blue font-weight-700 text-left text-uppercase font-size-14 d-flex align-center"
              style="width: 75%"
            >
              <v-icon small color="cyan darken-2" class="mr-1"
                >mdi-package-variant-closed</v-icon
              >
              {{ selectionLabelPlural }}
            </div>
            <div
              class="color-custom-blue font-weight-700 text-center text-uppercase font-size-14 d-flex align-center justify-center"
              style="width: 20%"
            >
              <v-icon small color="cyan darken-2" class="mr-1"
                >mdi-cube-outline</v-icon
              >
              Available Quantity
            </div>
          </div>
          <div style="overflow-y: auto; max-height: calc(100vh - 360px)">
            <div v-if="lProcessing" class="my-6 py-6 text-center">
              <v-progress-linear
                color="cyan"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </div>
            <div v-else-if="lDBLineItem && lDBLineItem.length">
              <div
                v-for="(row, index) in lDBLineItem"
                :key="index"
                class="d-flex align-center py-2 px-3 border-bottom border-slate-100 hover:bg-slate-50 transition-fast"
              >
                <div
                  class="font-weight-600 text-center d-flex justify-center"
                  style="width: 5%"
                >
                  <v-checkbox
                    v-model="row.status"
                    v-on:change="updateSelection(row)"
                    hide-details
                    class="my-0 py-0 px-0 mx-0 dense-checkbox"
                    color="cyan"
                  />
                </div>
                <div class="text-left" style="width: 75%">
                  <div class="d-flex align-center">
                    <div class="d-flex align-center mr-3">
                      <v-avatar size="32" class="mr-2 rounded-lg border">
                        <img
                          v-if="row?.image?.url"
                          :src="row?.image?.url"
                          :alt="row?.image?.name"
                        />
                        <img v-else :src="$defaultImage" />
                      </v-avatar>
                      <v-chip
                        v-if="row?.barcode"
                        label
                        color="cyan darken-3"
                        outlined
                        x-small
                        class="font-weight-700 mr-2"
                        >{{ row.barcode }}</v-chip
                      >
                    </div>
                    <div style="width: 100%" class="ml-0">
                      <v-text-field
                        v-model="row.product"
                        class="line-item-header-text px-0"
                        :placeholder="productType"
                        dense
                        filled
                        solo
                        flat
                        color="cyan"
                        readonly
                        hide-details
                      >
                        <template v-slot:append>
                          <v-chip
                            :color="
                              row?.isSerialized
                                ? 'green darken-1'
                                : 'red lighten-1'
                            "
                            style="max-width: 110px !important"
                            class="ml-2 font-weight-600"
                            small
                            label
                            text-color="white"
                          >
                            {{
                              row?.isSerialized
                                ? "Serialized"
                                : "Non-serialized"
                            }}
                          </v-chip>
                        </template>
                      </v-text-field>
                    </div>
                  </div>
                </div>
                <div class="text-center px-2" style="width: 20%">
                  <span class="font-weight-700 font-size-15 color-custom-blue">
                    {{ row.initial_stock }}
                  </span>
                </div>
              </div>
            </div>
            <div
              v-else
              class="d-flex flex-column align-center justify-center py-10 px-4 text-center"
            >
              <v-icon color="slate-300" large class="mb-2"
                >mdi-package-variant-closed</v-icon
              >
              <p class="m-0 font-size-15 font-weight-500 text-slate-500">
                Uhh... There are no items at the moment.
              </p>
            </div>
          </div>
          <ListingFooter
            :dataLoading="lProcessing"
            :showingFrom="showingFrom"
            :showingTo="showingTo"
            :totalRows="totalItems"
            :currentPage="currentPage"
            :totalPages="totalPages"
            removePage
          />
        </v-card>
      </div>
    </template>
  </Dialog>
</template>
<script>
import { mapGetters } from "vuex";
import Dialog from "@/view/pages/partials/Dialog.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import {
  GET_LINE_ITEM,
  SET_LOADING,
} from "@/core/services/store/line.item.module";
import { ErrorEventBus } from "@/core/lib/message.lib";
import { PaginationEventBus } from "@/core/lib/pagination.lib";

export default {
  name: "line-item-dialog-v2",
  props: {
    productType: {
      type: String,
      default: null,
    },
    productDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: null,
      category: "all",
      alphabet: "all",

      filter_categoty: null,
      selectedBarcodes: [],
      selectedItems: [],
      currentPage: 1,
      perPage: 20,
      totalPages: 1,
      totalItems: 0,
    };
  },
  components: {
    Dialog,
    ListingFooter,
  },
  methods: {
    updateSelection(row) {
      if (row.status) {
        if (!this.selectedBarcodes.includes(row.barcode)) {
          this.selectedBarcodes.push(row.barcode);
          this.selectedItems.push({ ...row });
        }
        return;
      }

      this.selectedBarcodes = this.selectedBarcodes.filter(
        (barcode) => barcode !== row.barcode
      );
      this.selectedItems = this.selectedItems.filter(
        (item) => item.barcode !== row.barcode
      );
    },
    clearSearch() {
      this.search = null;
      this.handleFilterChange();
    },
    handleFilterChange() {
      this.currentPage = 1;
      this.find_items(1);
    },
    find_items(page = 1) {
      let productType = this.productType;
      if (productType == "product") {
        productType = "goods";
      }
      this.currentPage = Number(page) > 0 ? Number(page) : 1;
      this.$store.dispatch(SET_LOADING, true);
      this.$store
        .dispatch(GET_LINE_ITEM, {
          module: "adjustment",
          type: productType,
          search: this.search,
          category: this.category,
          supplier: this.reSupplierId ?? null,
          per_page: this.perPage,
          current_page: this.currentPage,
        })
        .then((output) => {
          this.totalPages = Number(output.total_pages) || 1;
          this.totalItems = Number(output.total_rows) || 0;
          this.lDBLineItem.forEach((item) => {
            item.status = this.selectedBarcodes.includes(item.barcode);
          });
        })
        .catch(() => {
          this.totalPages = 1;
          this.totalItems = 0;
        })
        .finally(() => {
          this.$store.dispatch(SET_LOADING, false);
        });
    },
    handlePaginationUpdate(page) {
      if (!this.productDialog || !page) return;
      this.currentPage = Number(page);
      this.find_items(this.currentPage);
    },
    save_line_item() {
      const selected_line_items = [...this.selectedItems];
      let error = true;

      if (selected_line_items?.length > 0) {
        for (let item of selected_line_items) {
          this.lSelectedLineItem.forEach((row) => {
            if (row.barcode == item.barcode) {
              ErrorEventBus.$emit(
                "update:error",
                `${item.barcode} already used `
              );
              error = false;
              return false;
            }
          });
        }
      }
      if (!error) {
        return false;
      }
      if (!selected_line_items.length) {
        ErrorEventBus.$emit("update:error", `Please select Item.`);
        return false;
      }
      this.$emit("update-values", selected_line_items);
      this.$emit("close", true);
    },
    update_all_line_item(status) {
      for (let item of this.lDBLineItem) {
        item.status = status;

        if (status && !this.selectedBarcodes.includes(item.barcode)) {
          this.selectedBarcodes.push(item.barcode);
          this.selectedItems.push({ ...item });
        }

        if (!status) {
          this.selectedBarcodes = this.selectedBarcodes.filter(
            (barcode) => barcode !== item.barcode
          );
          this.selectedItems = this.selectedItems.filter(
            (selected) => selected.barcode !== item.barcode
          );
        }
      }
    },
    filter_cat(param) {
      this.category = param;
      this.handleFilterChange();
    },
    filter_alpha(param) {
      this.alphabet = param;
      this.handleFilterChange();
    },
  },
  beforeDestroy() {
    PaginationEventBus.$off("update:pagination", this.handlePaginationUpdate);
  },
  mounted() {
    PaginationEventBus.$on("update:pagination", this.handlePaginationUpdate);
    if (this.productDialog) {
      this.handleFilterChange();
    }
  },
  computed: {
    ...mapGetters([
      "reSupplierId",
      "lDBLineItem",
      "lProcessing",
      "lItemCategory",
      "lSelectedLineItem",
    ]),
    dialog_width() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 80);
    },
    getSelectedItem() {
      return this.selectedItems.length;
    },
    selectionLabel() {
      return this.productType === "parts" ? "Part" : "Product";
    },
    selectionLabelPlural() {
      return this.productType === "parts" ? "Parts" : "Products";
    },
    isAllVisibleSelected() {
      if (!this.lDBLineItem || !this.lDBLineItem.length) {
        return false;
      }
      return this.lDBLineItem.every((item) =>
        this.selectedBarcodes.includes(item.barcode)
      );
    },
    showingFrom() {
      return this.totalItems ? (this.currentPage - 1) * this.perPage + 1 : 0;
    },
    showingTo() {
      return this.totalItems
        ? Math.min(this.currentPage * this.perPage, this.totalItems)
        : 0;
    },
  },
};
</script>
<style scoped>
.custom_row {
  border-bottom: 1.5px solid #dbd7d7;
}
.custom_row:nth-child(even) {
  background: #fff4de;
}
.custom_row:hover {
  background: #fff4de;
}
</style>
